var exports = {
  "O": "authWarningIcon__MkTGNw",
};

module.exports = exports;
